import React from "react";

export default function Licenses() {
  return <div> Licenses page</div>;
}
